var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeatureScreening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "165px",
    height: "127px",
    viewBox: "0 0 165 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "feature-screening") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feature-screening",
    transform: "translate(0.050000, 0.523982)",
    fill: "#132735",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.09,21.7360181 L143.73,21.7360181 C139.423408,8.75890623 127.288045,0 113.615,0 C99.9419547,0 87.8065921,8.75890623 83.5,21.7360181 L10,21.7360181 C4.4771525,21.7360181 0,26.2131706 0,31.7360181 C0,37.2588656 4.4771525,41.7360181 10,41.7360181 L83.5,41.7360181 C87.8065921,54.7131299 99.9419547,63.4720361 113.615,63.4720361 C127.288045,63.4720361 139.423408,54.7131299 143.73,41.7360181 L154.09,41.7360181 C159.612847,41.7360181 164.09,37.2588656 164.09,31.7360181 C164.09,26.2131706 159.612847,21.7360181 154.09,21.7360181 L154.09,21.7360181 Z M113.61,43.4760181 C108.861613,43.4760181 104.580783,40.6156589 102.763654,36.2287216 C100.946525,31.8417842 101.95095,26.7922009 105.308566,23.4345844 C108.666183,20.076968 113.715766,19.0725434 118.102703,20.8896723 C122.489641,22.7068013 125.35,26.9876313 125.35,31.7360181 C125.33899,38.2152751 120.089257,43.4650083 113.61,43.4760181 L113.61,43.4760181 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,83.4760181 L80.42,83.4760181 C75.9209739,70.8280554 63.9493136,62.3800143 50.525,62.3800143 C37.1006864,62.3800143 25.1290261,70.8280554 20.63,83.4760181 L10,83.4760181 C4.4771525,83.4760181 0,87.9531706 0,93.4760181 C0,98.9988656 4.4771525,103.476018 10,103.476018 L20.19,103.476018 C24.2945766,116.78333 36.5940493,125.860875 50.52,125.860875 C64.4459507,125.860875 76.7454234,116.78333 80.85,103.476018 L154.09,103.476018 C159.612847,103.476018 164.09,98.9988656 164.09,93.4760181 C164.09,87.9531706 159.612847,83.4760181 154.09,83.4760181 L154.09,83.4760181 Z M50.52,105.836018 C44.036177,105.836018 38.78,100.579841 38.78,94.0960181 C38.78,87.6121951 44.036177,82.3560181 50.52,82.3560181 C57.003823,82.3560181 62.26,87.6121951 62.26,94.0960181 C62.2544861,100.577556 57.0015377,105.830504 50.52,105.836018 Z",
    id: "Shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureScreening);
export default __webpack_public_path__ + "static/media/feature-screening.47ea3ff552fcb12bc4553eff1c07bf6c.svg";
export { ForwardRef as ReactComponent };